import * as React from "react";
import {Link} from "react-router-dom";
import {WarningBanner, resourcesHelper} from "@ferry/portal-core";

export class NoActivePolicyBanner extends React.Component {

    public render() {
        return (
            <WarningBanner id="noActivePolicyBanner" wording={
                <>
                    There is no active policy in your {resourcesHelper.THEME_NAME} account. Check your old policies or, why not, {' '}
                    <Link to="/dashboard/getNewQuote" id="getNewQuote">get a new quote</Link>
                </>
            }/>
        );
    }
}
